<template>
  <v-combobox v-model="selectedItems" :items="items" :label="label" multiple chips single-line style="margin-top:6px;padding-top:0">
    <v-list-tile slot="prepend-item" ripple @click="selectAll()">
      <v-list-tile-action>
        <v-icon :color="selectedItems.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-title>Select All</v-list-tile-title>
    </v-list-tile>
    <v-divider slot="prepend-item" class="mt-2"></v-divider>
    <template slot="selection" slot-scope="{ item, index }">
      <v-chip v-if="index <= maxLength - 1">
        <span>{{ elementLengthFilter(item,elementMaxLength) }}</span>
      </v-chip>
      <span v-if="index === maxLength" class="grey--text caption">(+ {{ selectedItems.length-maxLength }}others)</span>
    </template>
  </v-combobox>
</template>

<script>
  export default {
    model: {
      prop: 'selectList',
      event: 'selectChange',
    },
    props: {
      selectList: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      label: {
        type: String,
        default: '',
      },
      maxLength: {
        type: Number,
        default: 1,
      },
      elementMaxLength: {
        type: Number,
        default: 100,
      },
    },
    data() {
      return {
        selectedItems: [],
      }
    },
    mounted() {
      this.selectedItems = this.selectList
    },
    computed: {
      selectAllItems() {
        return this.selectedItems.length === this.items.length
      },
      selectSomeItems() {
        return this.selectedItems > 0 && !this.selectAllItems
      },
      icon() {
        if (this.selectAllItems) return 'mdi-close-box'
        if (this.selectSomeItems) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
    },
    watch: {
      selectList() {
        this.selectedItems = this.selectList
      },
      selectedItems() {
        this.$emit('selectChange', this.selectedItems)
      },
    },
    methods: {
      selectAll() {
        if (this.selectAllItems) {
          this.selectedItems = []
        } else {
          this.selectedItems = [...this.items]
        }
      },
      elementLengthFilter(element, endPosition) {
        if (element.length > endPosition) {
          let temp = element.slice(0, endPosition)
          let suffix = '...'
          return temp.concat(suffix)
        }
        return element

      },
    },

  }
</script>